<div class="bg-background">
    <div class="analytics-dashboard">
        <form class="form-inline multi-filter-row d-flex gap-2 w-100 justify-content-end"
            [formGroup]="analyticsFilterForm" autocomplete="off">
            <div class="d-flex gap-2 align-items-center mb-3 mb-lg-0 px-lg-0 me-3">
                <label for="company-name" class="col-form-label pb-0">Company</label>
                <ng-select [searchable]="true" (search)="onCompanySearch($event)" [clearable]="true"
                    labelForId="company-name" [markFirst]="true" [items]="parentCompanyList"
                    [formControl]="selectedCompany" bindLabel="name" bindValue="id" appearance="outline"
                    class="pmd-select pmd-select-outline khr-header-entity-dropdown " placeholder="Company"
                    name="companyNameFilter" ng-click="active!= ng-select-opened" (close)="onCompanyDropdownClose()">
                </ng-select>
            </div>
            <div class="d-flex gap-2 align-items-center">
                <label for="select-entity" class="d-none d-lg-block">Entity</label>
                <ng-select groupBy="group" id="select-entity" name="select-entity" [items]="entities"
                    [formControl]="selectedEntities" appearance="outline" [multiple]="true" pmdTextField
                    placeholder="Select Entity" [clearable]="false" [clearSearchOnAdd]="true" bindLabel="name"
                    class="pmd-select pmd-select-outline khr-header-entity-dropdown-admin" (close)="reloadData()"
                    (change)="onEntityChangeAdmin()" (open)="onSelectionOpenAdmin();" [closeOnSelect]="false">
                    <ng-template ng-optgroup-tmp let-item="item">
                        <div class="d-flex gap-2 align-items-center text-secondary fs-14">
                            {{item.group}}
                        </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div class="pmd-checkbox-option"><span class="material-icons pmd-option-check"></span>
                            <div class="d-flex justify-content-between w-100 align-items-center">
                                <span>{{ item.name }}</span>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <!-- If ALL is selected -->
                        <div *ngIf="isAllSelected(items)" class="ng-value">
                            <span class="ng-value-label">All</span>
                        </div>

                        <!-- Otherwise normal behavior -->
                        <ng-container *ngIf="!isAllSelected(items)">
                            <div class="ng-value" *ngFor="let item of items | slice:0:1">
                                <span class="ng-value-label">{{item.name}}</span>
                            </div>

                            <div class="ng-value ts-more" *ngIf="items.length > 1">
                                <span class="ng-value-label">+{{items.length - 1}} more...</span>
                            </div>
                        </ng-container>
                    </ng-template>
                </ng-select>
            </div>
            <div class="date_and_select_group">
                <div class="d-flex align-items-center filter_dropdown-dashboard mb-0">
                    <pmd-input-group-outline class="khr-input-group-outline-icon input-group-sm khr-icon-r">
                        <pmd-textfield-outline>
                            <div class="duration-dropdown" pmdDropdown [positionFixed]="true"
                                (onShown)="onDurationPickerOpen()" [autoClose]="true" pmdPlacement="bottom-end">
                                <pmd-input-group-outline pmd-input-group-icon>
                                    <pmd-textfield pmd-textfield-outline>
                                        <input pmdTextField pmdDropdownToggle id="datePicker"
                                            class="form-control form-control-sm dropdown-toggle"
                                            formControlName="duration" aria-label="datepicker"
                                            aria-describedby="datepicker" readonly />
                                    </pmd-textfield>
                                </pmd-input-group-outline>
                                <div class="dropdown-menu date-mobile" *pmdDropdownMenu>
                                    <div>
                                        <div class="customrange-datepicker">
                                            <pmd-daterangepicker-inline (bsValueChange)="durationChange($event)"
                                                [bsConfig]="{ showWeekNumbers: false, todayHighlight: true}"
                                                [bsValue]="duration" [maxDate]="today">
                                                <div class="pmd-datepicker-predefined-btns pmd-datepicker-custom-range">
                                                    <h6 class="dropdown-header">Date selection</h6>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        (mouseenter)="getDuration('thisWeek')"
                                                        (mouseleave)="getDuration('reset')" (click)="setDuration()">
                                                        This Week
                                                    </a>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        (mouseenter)="getDuration('lastWeek')"
                                                        (mouseleave)="getDuration('reset')" (click)="setDuration()">
                                                        Last Week
                                                    </a>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        (mouseenter)="getDuration('fortnight')"
                                                        (mouseleave)="getDuration('reset')" (click)="setDuration()">
                                                        Last 15 Days
                                                    </a>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        (mouseenter)="getDuration('MTD')"
                                                        (mouseleave)="getDuration('reset')" (click)="setDuration()">
                                                        Month Till Date
                                                    </a>
                                                    <a class="dropdown-item" href="javascript:void(0);"
                                                        (mouseenter)="getDuration('YTD')"
                                                        (mouseleave)="getDuration('reset')" (click)="setDuration()">
                                                        Year Till Date
                                                    </a>
                                                    <a class="dropdown-item active" href="javascript:void(0);"
                                                        (mouseenter)="getDuration('today')"
                                                        (mouseleave)="getDuration('clear')">
                                                        Custom Range
                                                    </a>
                                                </div>
                                            </pmd-daterangepicker-inline>
                                            <div class="pmd-datepicker-buttons">
                                                <span class="ml-auto me-4">
                                                    <span class="ml-auto me-2 fromDateLable">
                                                        {{ duration[0].toLocaleDateString("en-US",
                                                        appGlobals.dateFormat) }}
                                                    </span>
                                                    <span class="ml-auto me-2"> to </span>
                                                    <span class="ml-auto me-2 toDateLable">
                                                        {{ duration[1].toLocaleDateString("en-US",
                                                        appGlobals.dateFormat) }}
                                                    </span>
                                                </span>
                                                <button pmd-btn (click)="getDuration('clear');setDuration()" pmdRipple
                                                    color="light" class="me-2 btn-light-gray">
                                                    Cancel
                                                </button>
                                                <button pmd-btn-raised (click)="setDuration()" pmdRipple
                                                    color="secondary">
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </pmd-textfield-outline>
                        <pmd-input-group-text class="pmd-input-icon-absolute border-0 bg-white">
                            <i class="material-icons pmd-icon-xs " color="secondary">calendar_month</i>
                        </pmd-input-group-text>
                    </pmd-input-group-outline>
                </div>
            </div>
        </form>
        <section>
            <div class="rounded-card">
                <h2 class="text-sm font-semibold text-foreground mb-3 px-1">Key Performance Indicators</h2>
                <div class="row">
                    <div class="col-md-2 mb-4">
                        <div class="card metric-card" [title]="globalMetrics.activeUsers.tooltip">

                            <div class="card-body">

                                <!-- Header -->
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="metric-label">
                                        {{globalMetrics.activeUsers.label}}
                                    </span>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" class="text-muted">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="9" cy="7" r="4"></circle>
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                    </svg>
                                </div>

                                <!-- Value + Growth -->
                                <div class="d-flex align-items-center gap-2">
                                    <span class="metric-value">
                                        {{globalMetrics.activeUsers.count}}
                                    </span>

                                    <span class="metric-growth"
                                        [ngClass]="{'text-success': +globalMetrics.activeUsers.comparison > 0, 'text-danger': +globalMetrics.activeUsers.comparison <= 0}">
                                        <span *ngIf="+globalMetrics.activeUsers.comparison > 0"><i
                                                class="bi bi-graph-up-arrow"></i></span>
                                        <span *ngIf="+globalMetrics.activeUsers.comparison <= 0"><i
                                                class="bi bi-graph-down-arrow"></i></span>
                                        {{globalMetrics.activeUsers.comparison | number:'1.2-2'}}%
                                    </span>
                                </div>

                                <!-- Footer -->
                                <div class="metric-subtext">
                                    {{globalMetrics.activeUsers.rateDescription}}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card metric-card" [title]="globalMetrics.cartConversion.tooltip">
                            <div class="card-body">

                                <!-- Header -->
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="metric-label">
                                        {{globalMetrics.cartConversion.label}}
                                    </span>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-shopping-cart w-4 h-4">
                                        <circle cx="8" cy="21" r="1"></circle>
                                        <circle cx="19" cy="21" r="1"></circle>
                                        <path
                                            d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12">
                                        </path>
                                    </svg>
                                </div>

                                <!-- Value + Growth -->
                                <div class="d-flex align-items-center gap-2">
                                    <span class="metric-value">
                                        {{globalMetrics.cartConversion.rate}}
                                    </span>

                                    <span class="metric-growth"
                                        [ngClass]="{'text-success': +globalMetrics.cartConversion.comparison > 0, 'text-danger': +globalMetrics.cartConversion.comparison <= 0}">
                                        <span *ngIf="+globalMetrics.cartConversion.comparison > 0"><i
                                                class="bi bi-graph-up-arrow"></i></span>
                                        <span *ngIf="+globalMetrics.cartConversion.comparison <= 0"><i
                                                class="bi bi-graph-down-arrow"></i></span>
                                        {{globalMetrics.cartConversion.comparison | number:'1.2-2'}}%
                                    </span>
                                </div>

                                <!-- Footer -->
                                <div class="metric-subtext">
                                    {{globalMetrics.cartConversion.rateDescription}}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card metric-card" [title]="globalMetrics.checkoutConversion.tooltip">
                            <div class="card-body">
                                <!-- Header -->
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="metric-label">
                                        {{globalMetrics.checkoutConversion.label}}
                                    </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-credit-card w-4 h-4">
                                        <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                                        <line x1="2" x2="22" y1="10" y2="10"></line>
                                    </svg>
                                </div>

                                <!-- Value + Growth -->
                                <div class="d-flex align-items-center gap-2">
                                    <span class="metric-value">
                                        {{globalMetrics.checkoutConversion.rate}}%
                                    </span>

                                    <span class="metric-growth"
                                        [ngClass]="{'text-success': +globalMetrics.checkoutConversion.comparison > 0, 'text-danger': +globalMetrics.checkoutConversion.comparison <= 0}">
                                        <span *ngIf="+globalMetrics.checkoutConversion.comparison > 0"><i
                                                class="bi bi-graph-up-arrow"></i></span>
                                        <span *ngIf="+globalMetrics.checkoutConversion.comparison <= 0"><i
                                                class="bi bi-graph-down-arrow"></i></span>
                                        {{globalMetrics.checkoutConversion.comparison | number:'1.2-2'}}%
                                    </span>
                                </div>

                                <!-- Footer -->
                                <div class="metric-subtext">
                                    {{globalMetrics.checkoutConversion.rateDescription}}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card metric-card" [title]="globalMetrics.purchaseCompletion.tooltip">
                            <div class="card-body">
                                <!-- Header -->
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="metric-label">
                                        {{globalMetrics.purchaseCompletion.label}}
                                    </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-search w-4 h-4">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <path d="m21 21-4.3-4.3"></path>
                                    </svg>
                                </div>

                                <!-- Value + Growth -->
                                <div class="d-flex align-items-center gap-2">
                                    <span class="metric-value">
                                        {{globalMetrics.purchaseCompletion.rate}}%
                                    </span>

                                    <span class="metric-growth"
                                        [ngClass]="{'text-success': +globalMetrics.purchaseCompletion.comparison > 0, 'text-danger': +globalMetrics.purchaseCompletion.comparison <= 0}">
                                        <span *ngIf="+globalMetrics.purchaseCompletion.comparison > 0"><i
                                                class="bi bi-graph-up-arrow"></i></span>
                                        <span *ngIf="+globalMetrics.purchaseCompletion.comparison <= 0"><i
                                                class="bi bi-graph-down-arrow"></i></span>
                                        {{globalMetrics.purchaseCompletion.comparison | number:'1.2-2'}}%
                                    </span>
                                </div>

                                <!-- Footer -->
                                <div class="metric-subtext">
                                    {{globalMetrics.purchaseCompletion.rateDescription}}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card metric-card" [title]="globalMetrics.overallConversion.tooltip">
                            <div class="card-body">
                                <!-- Header -->
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="metric-label">
                                        {{globalMetrics.overallConversion.label}}
                                    </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-package w-4 h-4">
                                        <path
                                            d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z">
                                        </path>
                                        <path d="M12 22V12"></path>
                                        <path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"></path>
                                        <path d="m7.5 4.27 9 5.15"></path>
                                    </svg>
                                </div>

                                <!-- Value + Growth -->
                                <div class="d-flex align-items-center gap-2">
                                    <span class="metric-value">
                                        {{globalMetrics.overallConversion.rate}}%
                                    </span>

                                    <span class="metric-growth"
                                        [ngClass]="{'text-success': +globalMetrics.overallConversion.comparison > 0, 'text-danger': +globalMetrics.overallConversion.comparison <= 0}">
                                        <span *ngIf="+globalMetrics.overallConversion.comparison > 0"><i
                                                class="bi bi-graph-up-arrow"></i></span>
                                        <span *ngIf="+globalMetrics.overallConversion.comparison <= 0"><i
                                                class="bi bi-graph-down-arrow"></i></span>
                                        {{globalMetrics.overallConversion.comparison | number:'1.2-2'}}%
                                    </span>
                                </div>

                                <!-- Footer -->
                                <div class="metric-subtext">
                                    {{globalMetrics.overallConversion.rateDescription}}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card metric-card" [title]="globalMetrics.totalOrderValue.tooltip">
                            <div class="card-body">
                                <!-- Header -->
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="metric-label">
                                        {{globalMetrics.totalOrderValue.label}}
                                    </span>
                                    <div class="icon-box">
                                        ₹
                                    </div>
                                </div>

                                <!-- Value + Growth -->
                                <div class="d-flex align-items-center gap-2">
                                    <span class="metric-value">
                                        {{+globalMetrics.totalOrderValue.amount | compactCurrency}}
                                    </span>

                                    <span class="metric-growth"
                                        [ngClass]="{'text-success': +globalMetrics.totalOrderValue.comparison > 0, 'text-danger': +globalMetrics.totalOrderValue.comparison <= 0}">
                                        <span *ngIf="+globalMetrics.totalOrderValue.comparison > 0"><i
                                                class="bi bi-graph-up-arrow"></i></span>
                                        <span *ngIf="+globalMetrics.totalOrderValue.comparison <= 0"><i
                                                class="bi bi-graph-down-arrow"></i></span>
                                        {{globalMetrics.totalOrderValue.comparison | number:'1.2-2'}}%
                                    </span>
                                </div>

                                <!-- Footer -->
                                <div class="metric-subtext">
                                    Sum of all order values
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h2 class="text-sm font-semibold text-foreground mb-3 px-1 mb-0">Funnel Analysis</h2>
                                <ul class="nav nav-pills custom-tabs p-1 mb-0">
                                    <li class="nav-item" (click)="onChangeTab('all')">
                                        <button class="nav-link" [ngClass]="{'active': activeTab == 'all'}">All</button>
                                    </li>
                                    <li class="nav-item" (click)="onChangeTab('hyperpure')">
                                        <button class="nav-link"
                                            [ngClass]="{'active': activeTab == 'hyperpure'}">Hyperpure</button>
                                    </li>
                                    <li class="nav-item" (click)="onChangeTab('udaan')">
                                        <button class="nav-link"
                                            [ngClass]="{'active': activeTab == 'udaan'}">Udaan</button>
                                    </li>
                                    <li class="nav-item" (click)="onChangeTab('dmart')">
                                        <button class="nav-link"
                                            [ngClass]="{'active': activeTab == 'dmart'}">DMart</button>
                                    </li>
                                    <li class="nav-item" (click)="onChangeTab('local')">
                                        <button class="nav-link"
                                            [ngClass]="{'active': activeTab == 'local'}">Local</button>
                                    </li>
                                </ul>
                            </div>
                            <div class="row g-4" *ngIf="funnelData?.length">

                                <div class="col-md-3" *ngFor="let item of funnelData; let i = index;">
                                    <div class="funnel-card" [class.highlight]="item.highlight">

                                        <div class="card-label"><span
                                                *ngIf="i != 0">{{this.removeUnderScore(item.label)}}</span>
                                            <div class="card-label d-flex align-items-center gap-1" *ngIf="i == 0">
                                                SEARCHES
                                                <i class="bi bi-info-circle"
                                                    title="Searches are cumulative across all suppliers"></i>
                                            </div>
                                        </div>

                                        <div class="card-value">{{item.value}}</div>

                                        <div class="card-metrics" [class.hide-metrics]="i == 0">
                                            <span class="text-success">{{item.conv}}%
                                                <small>conv</small></span>
                                            <span class="divider">|</span>
                                            <span class="text-danger">{{item.drop}}%
                                                <small>drop</small></span>
                                        </div>

                                        <div class="progress mt-2">
                                            <div class="progress-bar bg-success" [style.width.%]="item.conv"></div>
                                        </div>

                                        <div class="progress multi-progress mt-2"
                                            [class.invisible]="!item.supplierProgress?.length">
                                            <div *ngFor="let seg of item.supplierProgress" class="progress-segment"
                                                [style.width.%]="seg.percent" [style.background]="seg.color">
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div class="row mt-3" *ngIf="funnelData?.length">
                                <div class="col-12">

                                    <div class="insight-box">
                                        <span class="fw-medium">Insight:</span>
                                        Largest drop-off at
                                        <span class="fw-semibold text-danger">{{funnelAnalysisInsights}}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- <div class="mt-3">
            <div class="insight-wrapper d-flex align-items-center gap-3 flex-wrap">
                <span class="insight-title">INSIGHTS</span>
                <span class="divider-line"></span>
                <div class="insight-chip danger">
                    <i class="bi bi-exclamation-circle"></i>
                    Low overall conversion: 2.4%
                </div>
                <div class="insight-chip warning">
                    <i class="bi bi-exclamation-triangle"></i>
                    Checkout drop-off: 19.6% completion
                </div>
            </div>
        </div> -->

        <div class="mt-3">
            <h2 class="text-sm font-semibold text-foreground">Supplier Performance</h2>
            <div class="row g-4">
                <div class="col-md-3" *ngFor="let supplier of supplierPerformanceIndicatorData">
                    <div class="supplier-card hyperpure" [ngStyle]="{'background': supplier.backGround}">

                        <!-- Header -->
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div class="d-flex align-items-center gap-2">
                                <span class="dot purple" [ngStyle]="{'background': supplier.supplierIndicator}"></span>
                                <span class="title">{{supplier.name || ""}}</span>
                            </div>

                            <span class="badge badge-top" *ngIf="supplier.isBestPerformer">🏆 TOP</span>
                            <span *ngIf="supplier.isWorstPerformer" class="badge badge-low">⚠ LOW</span>
                        </div>

                        <!-- Metrics Row 1 -->
                        <div class="d-flex justify-content-between mb-2">
                            <div [title]="supplier.shareOfOrdersTooltip">
                                <div class="metric-supplier-label">
                                    <i class="bi bi-clock"></i>
                                    SHARE OF ORDERS
                                </div>
                                <div class="value">{{supplier.orders}}%</div>
                                <div class="progress">
                                    <div class="progress-bar purple"
                                        [ngStyle]="{'width': supplier.orders + '%', 'background': supplier.supplierIndicator}">
                                    </div>
                                </div>
                            </div>

                            <div class="text-end" [title]="supplier.conversionTooltip">
                                <div class="metric-label">
                                    <i class="bi bi-funnel"></i>
                                    CONVERSION
                                </div>
                                <div class="value text-success">{{supplier.conversionRate}}%</div>
                            </div>
                        </div>

                        <!-- Metrics Row 2 -->
                        <div class="d-flex justify-content-between mt-3">
                            <div [title]="supplier.checkoutTooltip">
                                <div class="metric-label">
                                    <i class="bi bi-check-circle"></i>
                                    CHECKOUT RATE
                                </div>
                                <div class="sub-value">{{supplier.checkoutRate}}%</div>
                            </div>

                            <div class="text-end" [title]="supplier.totalAddedTooltip">
                                <div class="metric-label">
                                    <i class="bi bi-box"></i>
                                    TOTAL ADDED
                                </div>
                                <div class="sub-value">{{supplier.totalAdded}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-6">
                <div class="card" *ngIf="chartOptions">
                    <div class="card-body">
                        <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                            [title]="chartOptions.title" [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis"
                            [stroke]="chartOptions.stroke" [colors]="chartOptions.colors"
                            [tooltip]="chartOptions.tooltip" [grid]="chartOptions.grid" [legend]="chartOptions.legend">
                        </apx-chart>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card" *ngIf="groupedBarChartOptions">
                    <div class="card-body">
                        <apx-chart [series]="groupedBarChartOptions.series" [chart]="groupedBarChartOptions.chart"
                            [title]="groupedBarChartOptions.title" [xaxis]="groupedBarChartOptions.xaxis"
                            [yaxis]="groupedBarChartOptions.yaxis" [dataLabels]="groupedBarChartOptions.dataLabels"
                            [colors]="groupedBarChartOptions.colors" [legend]="groupedBarChartOptions.legend"
                            [grid]="groupedBarChartOptions.grid" [tooltip]="groupedBarChartOptions.tooltip"
                            class="d-block">
                        </apx-chart>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-12">
                <div class="search-keyword-table">
                    <div class="card shadow-sm p-4">

                        <!-- Header -->
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h5 class="mb-0 fw-semibold">Search Insights</h5>

                            <div class="d-flex align-items-center gap-2">
                                <button class="btn btn-light border btn-sm" (click)="exportSearchKeywords()">
                                    ⬇ Export
                                </button>

                                <div class="search-box">
                                    <input type="text" placeholder="Search keywords..." class="form-control"
                                        [(ngModel)]="searchKeywordsInput" (input)="onSearchKeywords()">
                                </div>
                            </div>
                        </div>

                        <!-- Tabs -->
                        <div class="tabs mb-3">
                            <button class="tab" [ngClass]="{'active': keywordsActiveTab == 'top-keywords'}"
                                (click)="fetchKeywordsData('top-keywords')">Top Keywords</button>
                            <button class="tab" [ngClass]="{'active': keywordsActiveTab == 'keyword-conversion'}"
                                (click)="fetchKeywordsData('keyword-conversion')">Keyword Conversion</button>
                            <button class="tab" [ngClass]="{'active': keywordsActiveTab == 'failed_keywords'}"
                                (click)="fetchKeywordsData('failed_keywords')">Failed Keywords</button>
                        </div>

                        <!-- Table -->
                        <div class="table-wrapper">
                            <table class="table custom-table">
                                <ng-container *ngIf="keywordsActiveTab == 'top-keywords'">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>KEYWORD</th>
                                            <th>SEARCH COUNT</th>
                                            <th>USERS</th>
                                            <th>LAST USED</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let item of searchKeywords; let i = index">
                                            <td>
                                                <span class="rank">{{i + 1}}</span>
                                            </td>
                                            <td class="fw-medium">{{item.keyword}}</td>
                                            <td class="fw-semibold">{{item.searchCount}}</td>
                                            <td>{{item.users}}</td>
                                            <td class="text-muted">{{item.lastUsed}}</td>
                                        </tr>
                                    </tbody>
                                </ng-container>
                                <ng-container *ngIf="keywordsActiveTab == 'keyword-conversion'">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>KEYWORD</th>
                                            <th>Searches</th>
                                            <th>Cart Adds</th>
                                            <th>Conv. Rate</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <ng-container *ngFor="let item of searchKeywords; let i = index">
                                            <tr (click)="toggleRow(item)">
                                                <td>
                                                    <span class="rank">{{i + 1}}</span>
                                                </td>
                                                <td class="fw-medium"><span *ngIf="item.supplierBreakdown?.length"
                                                        class="arrow" [class.rotate]="item.open">
                                                        <i class="bi bi-chevron-right"></i>
                                                    </span>{{item.keyword}}</td>
                                                <td class="fw-semibold">{{item.searchCount}}</td>
                                                <td>{{item.cartAdds}}</td>
                                                <td class="text-muted">{{item.conversionRate}}</td>
                                                <td class="text-muted">
                                                    <span class="status-badge"
                                                        [ngClass]="{'healthy': item.status == 'Healthy', 'low': item.status == 'Low Conv'}">{{item.status}}</span>
                                                </td>
                                            </tr>
                                            <tr *ngIf="item.open">
                                                <td colspan="8">
                                                    <table class="inner-table w-100">
                                                        <thead>
                                                            <tr>
                                                                <th>Supplier Name</th>
                                                                <th>Times Added</th>
                                                                <th>Quantity</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let supplier of item.supplierBreakdown">
                                                                <td>{{supplier.name || ""}}</td>
                                                                <td>{{supplier.cartAdds || 0}}</td>
                                                                <td>{{supplier.quantity || 0}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </ng-container>
                                <ng-container *ngIf="keywordsActiveTab == 'failed_keywords'">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>KEYWORD</th>
                                            <th>Searches</th>
                                            <th>Users</th>
                                            <th>Cart Adds</th>
                                            <th>Last Used</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr *ngFor="let item of searchKeywords; let i = index">
                                            <td>
                                                <span class="rank">{{i + 1}}</span>
                                            </td>
                                            <td class="fw-medium">{{item.keyword}}</td>
                                            <td class="fw-semibold">{{item.searchCount}}</td>
                                            <td>{{item.users}}</td>
                                            <td class="text-muted">{{item.cartAdds}}</td>
                                            <td class="text-muted">{{item.lastUsed}}</td>
                                        </tr>
                                    </tbody>
                                </ng-container>
                            </table>
                        </div>
                        <app-table-loader *ngIf="isLoadingKeywords"></app-table-loader>
                        <app-data-not-found *ngIf="!searchKeywords.length && !isLoadingKeywords">
                        </app-data-not-found>
                        <app-invoice-pagination *ngIf="searchKeywords?.length && keywordsActiveTab == 'top-keywords'"
                            [id]="'compare-user-pagination-'+keywordsActiveTab" [count]="totalTopKeywords"
                            [page]="topKeywordsPage" [pageSize]="topKeywordsPageSize"
                            (pageChange)="onPageChange($event)" [pageName]="'Keyword'"
                            (pageSizeChange)="onPageSizeChange($event)">
                        </app-invoice-pagination>
                        <app-invoice-pagination
                            *ngIf="searchKeywords?.length && keywordsActiveTab == 'keyword-conversion'"
                            [id]="'compare-user-pagination-'+keywordsActiveTab" [count]="totalTopKeywords"
                            [page]="topKeywordsPage" [pageSize]="topKeywordsPageSize"
                            (pageChange)="onPageChange($event)" [pageName]="'Keyword'"
                            (pageSizeChange)="onPageSizeChange($event)">
                        </app-invoice-pagination>
                        <app-invoice-pagination *ngIf="searchKeywords?.length && keywordsActiveTab == 'failed_keywords'"
                            [id]="'compare-user-pagination-'+keywordsActiveTab" [count]="totalTopKeywords"
                            [page]="topKeywordsPage" [pageSize]="topKeywordsPageSize"
                            (pageChange)="onPageChange($event)" [pageName]="'Keyword'"
                            (pageSizeChange)="onPageSizeChange($event)">
                        </app-invoice-pagination>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-12">
                <div class="search-keyword-table">
                    <div class="card shadow-sm p-4">

                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h5 class="mb-0 fw-semibold">Order Logs</h5>

                            <div class="d-flex align-items-center gap-2">
                                <button class="btn btn-light border btn-sm" (click)="exportOrderLogs()"
                                    [disabled]="!orderLogs?.length">
                                    ⬇ Export
                                </button>

                                <div class="search-box">
                                    <input type="text" placeholder="Search orders..." class="form-control"
                                        [(ngModel)]="searchOrderLogsInput" (input)="onSearchOrderLogs()">
                                </div>
                            </div>
                        </div>

                        <div class="tabs mb-3">
                            <button class="tab" [ngClass]="{'active': orderLogsActiveTab == 'hyperpure'}"
                                (click)="fetchOrderLogs('hyperpure')">Hyperpure</button>
                            <button class="tab" [ngClass]="{'active': orderLogsActiveTab == 'udaan'}"
                                (click)="fetchOrderLogs('udaan')">Udaan</button>
                            <button class="tab" [ngClass]="{'active': orderLogsActiveTab == 'dmart'}"
                                (click)="fetchOrderLogs('dmart')">Dmart</button>
                            <button class="tab" [ngClass]="{'active': orderLogsActiveTab == 'local'}"
                                (click)="fetchOrderLogs('local')">Local</button>
                        </div>

                        <div class="table-wrapper order-logs-table-wrapper">
                            <table class="table custom-table order-logs-table">
                                <thead>
                                    <tr>
                                        <th>Entity Name</th>
                                        <th>Order Date</th>
                                        <th>Order Amount</th>
                                        <th>Order Number</th>
                                    </tr>
                                </thead>
                                <ng-container *ngIf="orderLogs?.length">
                                    <tbody>
                                        <tr *ngFor="let orderLog of orderLogs">
                                            <td>{{orderLog.entityName || ""}}</td>
                                            <td>{{orderLog.orderDate | date}}</td>
                                            <td>₹{{orderLog.orderAmount || ""}}</td>
                                            <td>#{{orderLog.orderNumber || ""}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>Total</td>
                                            <td>{{orderLogs.length}} orders</td>
                                            <td>₹{{orderLogsSum}}</td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </ng-container>
                            </table>
                        </div>
                        <app-table-loader *ngIf="isLoadingOrderLogs"></app-table-loader>
                        <app-data-not-found *ngIf="!orderLogs.length && !isLoadingOrderLogs">
                        </app-data-not-found>
                        <app-invoice-pagination *ngIf="orderLogs?.length && orderLogsActiveTab == 'hyperpure'"
                            [id]="'compare-user-pagination-'+orderLogsActiveTab" [count]="totalOrderLogs"
                            [page]="orderLogsPage" [pageSize]="orderLogsPageSize"
                            (pageChange)="onOrderLogsPageChange($event)" [pageName]="'Order Log'"
                            (pageSizeChange)="onOrderLogsPageSizeChange($event)">
                        </app-invoice-pagination>
                        <app-invoice-pagination *ngIf="orderLogs?.length && orderLogsActiveTab == 'udaan'"
                            [id]="'compare-user-pagination-'+orderLogsActiveTab" [count]="totalOrderLogs"
                            [page]="orderLogsPage" [pageSize]="orderLogsPageSize"
                            (pageChange)="onOrderLogsPageChange($event)" [pageName]="'Order Log'"
                            (pageSizeChange)="onOrderLogsPageSizeChange($event)">
                        </app-invoice-pagination>
                        <app-invoice-pagination *ngIf="orderLogs?.length && orderLogsActiveTab == 'dmart'"
                            [id]="'compare-user-pagination-'+orderLogsActiveTab" [count]="totalOrderLogs"
                            [page]="orderLogsPage" [pageSize]="orderLogsPageSize"
                            (pageChange)="onOrderLogsPageChange($event)" [pageName]="'Order Log'"
                            (pageSizeChange)="onOrderLogsPageSizeChange($event)">
                        </app-invoice-pagination>
                        <app-invoice-pagination *ngIf="orderLogs?.length && orderLogsActiveTab == 'local'"
                            [id]="'compare-user-pagination-'+orderLogsActiveTab" [count]="totalOrderLogs"
                            [page]="orderLogsPage" [pageSize]="orderLogsPageSize"
                            (pageChange)="onOrderLogsPageChange($event)" [pageName]="'Order Log'"
                            (pageSizeChange)="onOrderLogsPageSizeChange($event)">
                        </app-invoice-pagination>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="cart-product-insights">
                <div class="card shadow-sm p-4">

                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="fw-semibold mb-0">User Behavior Insights</h5>

                        <div class="d-flex gap-2">
                            <button class="btn btn-light border btn-sm" (click)="exportUserBehaviorInsights()">⬇
                                Export</button>
                            <input type="text" class="form-control search-input" placeholder="Search users..."
                                [(ngModel)]="searchUserBehaviorInput" (input)="onSearchUserBehavior()">
                        </div>
                    </div>

                    <div class="table-wrapper">
                        <table class="table custom-table">
                            <thead>
                                <tr>
                                    <th>USER</th>
                                    <th>SEARCHES</th>
                                    <th>CART ADDS</th>
                                    <th>CHECKOUTS</th>
                                    <th>ORDERS</th>
                                    <th>ORDER AMT</th>
                                    <th>CONV. RATE</th>
                                    <th>SEGMENT</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let user of userBehaviorInsights">
                                    <td>{{user.userName || ""}}</td>
                                    <td>{{user.searches }}</td>
                                    <td>{{user.cartAdds }}</td>
                                    <td>{{user.checkouts}}</td>
                                    <td>{{user.orders }}</td>
                                    <td>{{user.orderAmount}}</td>
                                    <td>{{user.conversionRate}}</td>
                                    <td>{{user.segment}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <app-table-loader *ngIf="isUserBehaviorInsightsLoading"></app-table-loader>
                    <app-data-not-found *ngIf="!userBehaviorInsights.length && !isUserBehaviorInsightsLoading">
                    </app-data-not-found>
                    <app-invoice-pagination *ngIf="userBehaviorInsights?.length" [id]="'compare-user-pagination'"
                        [count]="totalUserBehaviorInsights" [page]="userBehaviorInsightsPage"
                        [pageSize]="userBehaviorInsightsPageSize"
                        (pageChange)="onUserBehaviorInsightsPageChange($event)" [pageName]="'User'"
                        (pageSizeChange)="onUserBehaviorInsightsPageSizeChange($event)">
                    </app-invoice-pagination>
                </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="cart-product-insights">
                <div class="card shadow-sm p-4">

                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="fw-semibold mb-0">Entity Behavior Insights</h5>

                        <div class="d-flex gap-2">
                            <button class="btn btn-light border btn-sm" (click)="exportEntityBehaviorInsights()">⬇
                                Export</button>
                            <input type="text" class="form-control search-input" placeholder="Search entities..."
                                [(ngModel)]="searchEntityBehaviorInput" (input)="onSearchEntityBehavior()">
                        </div>
                    </div>

                    <div class="table-wrapper">
                        <table class="table custom-table">
                            <thead>
                                <tr>
                                    <th>ENTITY NAME (COMPANY)</th>
                                    <th>SEARCHES</th>
                                    <th>CART ADDS</th>
                                    <th>CHECKOUTS</th>
                                    <th>ORDERS</th>
                                    <th>ORDER AMT</th>
                                    <th>CONV. RATE</th>
                                    <th>SEGMENT</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let entity of entityBehaviorInsights">
                                    <td>{{getEntityDisplayName(entity)}}</td>
                                    <td>{{entity.searches }}</td>
                                    <td>{{entity.cartAdds }}</td>
                                    <td>{{entity.checkouts}}</td>
                                    <td>{{entity.orders }}</td>
                                    <td>{{entity.orderAmount}}</td>
                                    <td>{{entity.conversionRate}}</td>
                                    <td>{{entity.segment}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <app-table-loader *ngIf="isEntityBehaviorInsightsLoading"></app-table-loader>
                    <app-data-not-found *ngIf="!entityBehaviorInsights.length && !isEntityBehaviorInsightsLoading">
                    </app-data-not-found>
                    <app-invoice-pagination *ngIf="entityBehaviorInsights?.length" [id]="'compare-entity-pagination'"
                        [count]="totalEntityBehaviorInsights" [page]="entityBehaviorInsightsPage"
                        [pageSize]="entityBehaviorInsightsPageSize"
                        (pageChange)="onEntityBehaviorInsightsPageChange($event)" [pageName]="'Entitie'"
                        (pageSizeChange)="onEntityBehaviorInsightsPageSizeChange($event)">
                    </app-invoice-pagination>
                </div>
            </div>
        </div>
    </div>
</div>